export default "__VITE_ASSET__CJmqRqSK__"